export default "__VITE_ASSET__DUXb1zhK__"